var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.32 24.3864C40.32 23.181 40.2118 22.0219 40.0109 20.9091H24V27.4851H33.1491C32.755 29.6101 31.5573 31.4105 29.7568 32.616V36.8814H35.2509C38.4654 33.9219 40.32 29.5637 40.32 24.3864Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41.0001C28.59 41.0001 32.4382 39.4778 35.2509 36.8814L29.7568 32.616C28.2345 33.636 26.2873 34.2387 24 34.2387C19.5722 34.2387 15.8245 31.2482 14.4877 27.23H8.80814V31.6346C11.6054 37.1905 17.3545 41.0001 24 41.0001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4877 27.2301C14.1477 26.2101 13.9545 25.1206 13.9545 24.0001C13.9545 22.8796 14.1477 21.7901 14.4877 20.7701V16.3655H8.80812C7.65676 18.6605 6.99994 21.2569 6.99994 24.0001C6.99994 26.7433 7.65676 29.3397 8.80812 31.6347L14.4877 27.2301Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13.7614C26.4959 13.7614 28.7368 14.6192 30.4986 16.3037L35.3745 11.4278C32.4304 8.68461 28.5823 7.00006 24 7.00006C17.3545 7.00006 11.6054 10.8096 8.80814 16.3655L14.4877 20.7701C15.8245 16.7519 19.5722 13.7614 24 13.7614Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.2d1bb712ad8bfa5b5315aeebf761a481.svg";
export { ForwardRef as ReactComponent };